import React, { useContext } from 'react';
import { FaArrowDown, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import { BusinessStatusContext } from '../contexts/BusinessStatusContext';
import FrontPageBasket from './FrontPageBasket';
import Menu from './Menu';

function HomePage() {
    const { businessStatus, businessStatusLoading } = useContext(BusinessStatusContext);
    const isOpen = businessStatus?.canPlaceOrders;

    return (
        <main>
            <section className="home-hero">
                <div className="home-hero__image" />
                <div className="home-hero__content">
                    <p className="eyebrow">Vegetarian food, made with care</p>
                    <h1>Comfort food with a bold local flavour.</h1>
                    <p className="hero-copy">Freshly prepared vegetarian meals, quick bites and sweet treats from Divine Veg on 262.</p>
                    <a className="button button--primary" href="#menu">View the menu <FaArrowDown /></a>
                </div>
                <div className={`order-status ${isOpen ? 'order-status--open' : 'order-status--closed'}`}>
                    <span className="status-dot" />
                    <b>{businessStatusLoading ? 'Checking orders' : isOpen ? 'Ordering now open' : 'Ordering currently closed'}</b>
                    <small>{businessStatus?.banner?.message}</small>
                </div>
            </section>
            <section className="service-strip" aria-label="Service details">
                <div><FaClock /><span><b>Order hours</b>Monday to Friday, 7 AM to 5 PM</span></div>
                <div><FaMapMarkerAlt /><span><b>Delivery areas</b>Tongaat, Seatides, Westbrook, La Mercy and Ballito, plus nearby areas within 25 km by road.</span></div>
            </section>
            <Menu />
            <FrontPageBasket />
        </main>
    );
}

export default HomePage;
